<template>
   <QBtn class="q-ml-md" color="negative" size="sm" @click="handleLogout"
      ><QIcon name="mdi-logout"
   /></QBtn>
</template>

<script setup lang="ts">
import { QBtn, QIcon } from "quasar"
import { useClerk } from "@clerk/vue"
import { clearAllState } from "@utils/stateManagement"
import { collectError } from "@utils/errors"
import { toast } from "vue3-toastify"

const clerk = useClerk()

const handleLogout = async () => {
   try {
      await clerk.value?.signOut()
      clearAllState()
      window.location.href = "/signed-out"
   } catch (error) {
      collectError(error as Error)
      toast.error("Error logging out")
   }
}
</script>
